import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { ColumnProps } from 'antd/es/table';
import { Offer, OfferSearchParams } from '../../stores/offer';
import { useAuthStore, useOfferStore } from '../../contexts/mobx';
import { useSearchParams } from '../../utils/use-search-params';
import { useNavigation } from '../../utils/use-navigation';
import { getItemProp } from '../../utils';
import { CreateButton } from '../../components/action-buttons';
import { PaginationBar } from '../../components/pagination/pagination-bar';
import { PageTopBar } from '../../components/page-top-bar';
import { SearchInput } from '../../components/search-input';
import { Tag } from '../../components/tag';

const renderTitle = (_: unknown, record: Offer) => {
    const enTitle = getItemProp(record.items, 'en', 'title');
    const frTitle = getItemProp(record.items, 'fr', 'title');
    return (
        <div>
            {enTitle}
            <br />
            <span className="light_label">{frTitle}</span>
        </div>
    );
};

const renderIsActive = () => {
    // eslint-disable-next-line no-constant-condition
    return true ? (
        <Tag variant="success">Active</Tag>
    ) : (
        <Tag variant="error">Not active</Tag>
    );
};

export const OffersPage = observer(() => {
    const offerStore = useOfferStore();
    const navigation = useNavigation();
    const authStore = useAuthStore();

    const { hasManagementAccess } = authStore;

    if (!hasManagementAccess) {
        navigation.goToHome();
    }
    const search = useSearchParams<OfferSearchParams>();

    React.useEffect(() => {
        offerStore.fetchPaginatedOffers(search.params);
    }, [offerStore, search.params]);

    const columns: ColumnProps<Offer>[] = [
        {
            title: 'Title',
            key: 'title',
            width: '20%',
            render: renderTitle,
        },
        {
            title: 'Is active',
            key: 'is_active',
            render: renderIsActive,
            width: '10%',
        },
    ];

    const goToEditPage = (o: Offer) => () => {
        navigation.goToOfferEdit(o.id);
    };

    return (
        <>
            <PageTopBar title="Promotional Offers">
                <CreateButton onClick={() => navigation.goToOfferCreate()} />
            </PageTopBar>

            <div className="action_zone_above_table">
                <div className="table_header_options_bar">
                    <div className={'query_box'}>
                        <SearchInput
                            searchValue={search.params.q}
                            onChange={(e) =>
                                search.setParams({ q: e.target.value, page: 0 })
                            }
                            allowClear={true}
                            placeholder="Search"
                        />
                    </div>
                </div>
                <PaginationBar
                    pagination={{
                        page: search.params.page,
                        pageSize: search.params.perPage,
                        total: offerStore.paginatedOffers?.total,
                        onPageChange: (page) => search.setParams({ page }),
                        onPageSizeChange: (perPage) =>
                            search.setParams({ perPage, page: 0 }),
                    }}
                />
            </div>

            <Table<Offer>
                className="clickable_table_body_rows"
                rowKey="id"
                dataSource={offerStore.paginatedOffers?.results}
                columns={columns}
                loading={offerStore.isFetchingPaginatedCount > 0}
                pagination={false}
                onRow={(r) => ({
                    onClick: goToEditPage(r),
                })}
            />
        </>
    );
});
